<template>
  <div class="books">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>馆藏著作</h4>
      </div>
      <!-- <div class="head-right-btn">
        <el-button
          type="info"
          size="medium"
          @click="addProjects"
        >添加项目</el-button>
      </div> -->
    </div>
    <!-- 抬头结束 -->
    <!-- 内容 -->
    <div class="books-box">
      <ul class="books-box-ul">
        <li
          class="books-box-item"
          v-for="(item, index) in aprenderObject.list"
          :key="index"
          @click="booksBoxClick(item)"
        >
          <div class="books-box-item-img">
            <img :src="item.logo" />
          </div>
        </li>
      </ul>
      <div class="available" v-if="aprenderObject.list.length == 0">
        暂无数据
      </div>
    </div>
    <!-- 内容 结束 -->
    <!-- 分页 -->
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :current-page.sync="currentPage"
        :page-count="aprenderObject.pages"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "books",
  data() {
    return {
      pagesize: 12, //每页显示条目个数
      currentPage: 1, //当前页数
      aprenderObject: {
        list: [],
      },
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    //列表
    async getList() {
      const { data: data } = await this.$http.post("library/list", {
        page: this.currentPage,
        limit: this.pagesize,
        name: "",
      });
      this.aprenderObject = data.data;
      this.$Spin.hide();
    },
    //详情
    booksBoxClick(item) {
      this.$router.push({
        path: "/booksLiterature",
        query: {
          id: item.id,
        },
      });
    },
    //点击每一页
    currentchange(e) {
      this.currentPage = e;
      document.querySelector(".el-main").scrollTop = 0;
      setTimeout(() => {
        this.getList();
      }, 500);
      this.$Spin.show();
    },
    //上一页
    prevClick(e) {
      this.currentPage = e;
      document.querySelector(".el-main").scrollTop = 0;
      setTimeout(() => {
        this.getList();
      }, 500);
      this.$Spin.show();
    },
    //下一页
    nextClick(e) {
      this.currentPage = e;
      document.querySelector(".el-main").scrollTop = 0;
      setTimeout(() => {
        this.getList();
      }, 500);
      this.$Spin.show();
    },
  },
};
</script>

<style lang="less" scoped>
.books {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }

    .head-right {
      display: flex;

      .head-right-btn {
        margin-left: 167px;
      }

      .inputBox {
        flex: 1;
        display: flex;

        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }
    }
  }

  .books-box {
    width: 100%;
    min-height: 645px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    .books-box-ul {
      padding-bottom: 45px;
      display: flex;
      flex-wrap: wrap;

      .books-box-item {
        // width: 270px;
        // height: 140px;
        width: 226px;
        height: 310px;
        background-color: #fff;
        margin-top: 46px;
        margin-left: 72px;
        // background-color: pink;
        // margin: 45px 50px 0 70px;
        // border-radius: 8px;
        // box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.16);
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        .books-box-item-img {
          width: 100%;
          height: 100%;

          // width: 230px;
          // height: 96px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .page {
    margin-top: 30px;
    text-align: right;
  }

  .available {
    text-align: center;
    margin-top: 240px;
    color: #756bb1;
  }
}
</style>
